export class ValidateLogin {
  static readonly type = '[ValidateLogin] ValidateLogin';
  constructor(public token: string) { }
}

export class ResetValidateLoginState {
  static readonly type = '[ValidateLogin] ResetValidateLoginState';
}